// import { lazy } from 'react';

export const portal = [
	{
		// 	path: '/portal',
		// 	Component: lazy(() => import('../pages/Portal')),
		// 	children: [
		// 		{
		// 			path: '/portal/search-for-adverts/',
		// 			Component: lazy(() => import('../pages/Portal/Search'))
		// 		},
		// 		{
		// 			path: '/portal/my-adverts/',
		// 			Component: lazy(() => import('../pages/Portal/MyAdverts'))
		// 		},
		// 		{
		// 			path: '/portal/my-adverts/new',
		// 			Component: lazy(() => import('../pages/Portal/NewAdvert'))
		// 		}
		// 	]
	}
];
